const B2C_METHOD_PREFIX = "b2c";

export const B2C_METHOD_TEST_IDS = {
    CONTAINER: `${B2C_METHOD_PREFIX}_container`,
    ICON: `${B2C_METHOD_PREFIX}_icon`,
    NAME: `${B2C_METHOD_PREFIX}_name`,
    DISABLE_MESSAGE: `${B2C_METHOD_PREFIX}_disable_msg`,
    TICK: `${B2C_METHOD_PREFIX}_tick`,
    PAY_BUTTON: `${B2C_METHOD_PREFIX}_pay_btn`,
    BILL_UPLOAD_HALF_CARD: `${B2C_METHOD_PREFIX}_bill_upload_half_card`,
    BILL_UPLOAD_PROCEED: `${B2C_METHOD_PREFIX}_bill_upload_proceed`,
    BILL_UPLOAD_CANCEL: `${B2C_METHOD_PREFIX}_bill_upload_cancel`,
    BILL_UPLOAD_CLOSE: `${B2C_METHOD_PREFIX}_bill_upload_close`,
};
